import * as React from 'react';
import { Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { CheckIconOutlined } from '../../../custom_shared/icons';
import { ClaimProcessingResultDto } from '../../../common/services/types';
import './ClaimProcessingResultRenderer.less';

type Props = {
    result?: ClaimProcessingResultDto | null;
};

const ClaimProcessingResultRenderer: React.FC<Props> = ({ result }) => {
    if (!result) {
        return null;
    }

    const renderCopyableItem = (label: string, value?: string | null) => {
        if (!value) {
            return null;
        }

        return (
            <div className="single-item-container">
                <span className="key-label">{label}:</span>
                <span>{value}</span>
                <Tooltip title="Copy">
                    <CopyOutlined className="copy-icon" onClick={() => navigator.clipboard.writeText(value)} />
                </Tooltip>
            </div>
        );
    };

    const renderItem = (label: string, value?: string | null) => {
        if (!value) {
            return null;
        }

        return (
            <div className="single-item-container">
                <span className="key-label">{label}:</span>
                <span>{value}</span>
            </div>
        );
    };

    return (
        <div className="claim-processing-result-renderer-container">
            <div className="results-content">
                <div className="results-left-column">
                    <CheckIconOutlined />
                </div>

                <div className="results-right-column">
                    <span>Claim created successfully in SICS.</span>
                    {renderCopyableItem('Claim ID', result.claimId)}
                    {renderCopyableItem('Business ID', result.businessId)}
                    {renderItem('Business name', result.businessName)}
                    {renderItem('Claim name', result.claimName)}
                </div>
            </div>
        </div>
    );
};

export default ClaimProcessingResultRenderer;
